import React, { useState, useEffect, useRef, Fragment, useCallback } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Container from 'react-bootstrap/Container';
import PropTypes from "prop-types";
import countries from "../../../utils/countries";
import PostCodeSearch from "./PostCodeSearch";
import { getFieldError } from "../../../utils/formValidation";
import DiscountCode from "../../confirmation/confirmation-components/DiscountCode";
import { useNavigate } from "react-router-dom";

const SchoolDetails = (props) => {

    const [showForm, setShowForm] = useState(false);
    const [disableAutoFormFields, setDisableAutoFormFields] = useState(false);
    const [formValid, setFormValid] = useState(false)
    const [dataAdminSelect, setDataAdminSelect] = useState(false);
    const [requireDataManager, setRequireDataManager] = useState(false);
    const [anchorEl, setAnchorEl] =useState(null);
    const [formValues, setFormValues] = useState({
      purchaseOrder: "",
      contactName: "",
      position: "",
      centreName: "",
      dfeNumber: "",
      vatNumber: "",
      postcode: "",
      country: "",
      centreAddress: "",
      phone: "",
      centreEmail: "",
      centreEmailConfirm: "",
      financeEmail: "",
      financeEmailConfirm: "",
      referal: "",
      termsAndConditions: false,
      ordertheseJSON: "",
      subtotal: "",
      vattotal: ""
    });
    const [formErrors, setFormErrors] = useState({
      contactName: "",
      phone: "",
      position: "",
      centreEmail: "",
      centreEmailConfirm: "",
      financeEmail: "",
      financeEmailConfirm: "",
      termsAndConditions: "",
      centreName: "",
      centreAddress: "",
      postcode: ""
    });
    const [form, setForm] = useState({
      position: [
        "Headteacher",
        "Teacher",
        "HOD",
        "Exams Officer",
        "ICT Coordinator",
        "Assessment Coordinator",
        "Admin",
        "Bursar/Finance",
        "Adviser"
      ],
      referal: [
        {
          name: "Word of mouth",
          code: 1
        },
        {
          name: "Direct mail",
          code: 2
        },
        {
          name: "Email",
          code: 3
        },
        {
          name: "Search engine",
          code: 4
        },
        {
          name: "Exhibition",
          code: 5
        },
        {
          name: "AQA",
          code: 6
        },
        {
          name: "Social media",
          code: 7
        },
        {
          name: "Other",
          code: 8
        },
        {
          name: "Don't know",
          code: 9
        },
        {
          name: "-",
          code: 10
        }
      ]
    });
    const [phoneLabel, setPhoneLabel] = useState("Phone number");
    const [manualEntry, setManualEntry] = useState(false);
    const [centreNameLabel, setCentreNameLabel] = useState();
    const [centreAddressLabel, setCentreAddressLabel] = useState();
    const [postcodeLabel, setpostcodeLabel] = useState();
  
    const usePrevious = (value) => {
      const ref = useRef();
        useEffect(() => {
          ref.current = value;
        }, [value]);
        return ref.current;
    };

    const previousFormErrors = JSON.stringify(usePrevious(formErrors));
    const previousFormValuesProps = JSON.stringify(usePrevious(props.formValues));

    const setFormVisibility = value => {
      setShowForm(value);
    };

  const handleInputChange = event => {
    let newFormErrors = { ...formErrors };
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    const newFormValues = { ...formValues };
    newFormValues[name] = value;
    if (target.type === "checkbox") {
      newFormErrors[name] = !value;
    }
    setFormValues(newFormValues);
    setFormErrors(newFormErrors);
  };

  const inputIsError = value => {
    if (value.length > 0) {
      return false;
    }
    return true;
  };

  // runs on blur but not as part of validateForm
  const handleBlur = name => {
    let errorMessage = "This is a required field";
    let newFormErrors = { ...formErrors };
    let newFormValues = { ...formValues };
    let isError = inputIsError(newFormValues[name]);
    const emailError = "Emails do not match";

    if (name.includes("Email") && !isError) {
      getFieldError(name, newFormValues).then(result => {
        result !== "Valid address, domain found"
          ? (isError = result)
          : (isError = false);
        newFormErrors[name] = isError;
        setFormErrors(newFormErrors);
      });
    } else {
      newFormErrors[name] = isError ? errorMessage : false;
      setFormErrors(newFormErrors);
    }

    if (name === "centreEmail") {
      newFormValues.centreEmailConfirm === newFormValues.centreEmail
        ? (newFormErrors.centreEmailConfirm = false)
        : (newFormErrors.centreEmailConfirm = emailError);

      setFormErrors(newFormErrors);
    }

    if (name === "financeEmail") {
      newFormValues.financeEmailConfirm === newFormValues.financeEmail
        ? (newFormErrors.financeEmailConfirm = false)
        : (newFormErrors.financeEmailConfirm = emailError);

      setFormErrors(newFormErrors);
    }
  };

  const confirmValue = (input, control) => {
    let newFormErrors = { ...formErrors };
    const newFormValues = { ...formValues };

    if (newFormValues[input] === newFormValues[control]) {
      newFormErrors[input] = false;
    } else {
      newFormErrors[input] = "Emails do not match";
    }
    setFormErrors(newFormErrors);
  };

  // return true if form valid
  const validateForm = () => {
    let getFormErrors = { ...formErrors };
    let errorMessage = "This is a required field";
    let returnValue = true;

    if (manualEntry) {
      if (!formValues.centreName) {
        getFormErrors.centreName = errorMessage;
        returnValue = false;
      }
      if (!formValues.centreAddress) {
        getFormErrors.centreAddress = errorMessage;
        returnValue = false;
      }
      if (!formValues.postcode) {
        getFormErrors.postcode = errorMessage;
        returnValue = false;
      }
    }
    //Empty string if no error
    for (let keyOfObject in getFormErrors) {
      if (getFormErrors[keyOfObject] || getFormErrors[keyOfObject] === "") {
        setFormValid(false);
        returnValue = false;
      }
      
      if (!getFormErrors.termsAndConditions) {
        if (
          getFormErrors[keyOfObject] === true ||
          getFormErrors[keyOfObject] === ""
          ) {
            getFormErrors[keyOfObject] = errorMessage;
          }
        }
        
        setFormErrors(getFormErrors);
    }
    return returnValue && formValues.termsAndConditions;
  };

  let navigate = useNavigate()
  const handleForm = () => {
    if (validateForm()) {
      props
        .submitOrder(formValues)
        .then(order => {
          navigate(`/confirmation?brand=${props.brand}&s=${order[0].orderkey}`)
          props.resetBasket();
        })
        .catch(error => console.log("the submission errored", error))
        
      } else {
        // do nothing, the validation will do the heavy lifting and display errors to the user
      }
  };

  const updateForm = school => {
    const newFormValues = { ...formValues };
    Object.entries(school).forEach(([key, value]) => (newFormValues[key] = value));

    setFormValues(newFormValues);
  };

  const enableAutoFormFields = () => {
    const getFormErrors = { ...formErrors };
    getFormErrors.centreAddress = "";
    getFormErrors.centreName = "";
    getFormErrors.postcode = "";

    setFormErrors(getFormErrors);
    setDisableAutoFormFields(false);
    setManualEntry(true);
  };

  useEffect(() => {
    removeAutoFormFieldErrors()
    if (manualEntry) {
      setCentreNameLabel("School name*");
      setCentreAddressLabel("School address*");
      setpostcodeLabel("Postcode*");
    }  else {
      setCentreNameLabel("School name");
      setCentreAddressLabel("School address");
      setpostcodeLabel("Postcode");
    }
  },[manualEntry])

  const removeAutoFormFieldErrors = useCallback(() => {
    // make a new copy of formErrors, with auto form fields removed, and set this as the new formErrors in state
    // this is to stop fields filled in by the database cuasing errors and an invalid form
    const getFormErrors = { ...formErrors };
    if (props.paperPackage && manualEntry) {
      const newFormErrors = {
        contactName: getFormErrors.contactName,
        phone: getFormErrors.phone,
        position: getFormErrors.position,
        centreEmail: getFormErrors.centreEmail,
        centreEmailConfirm: getFormErrors.centreEmailConfirm,
        financeEmail: getFormErrors.financeEmail,
        financeEmailConfirm: getFormErrors.financeEmailConfirm,
        termsAndConditions: getFormErrors.termsAndConditions,
        centreName: getFormErrors.centreName,
        centreAddress: getFormErrors.centreAddress,
        postcode: getFormErrors.postcode,
      };
      setFormErrors(newFormErrors);
      manualEntry ? setDisableAutoFormFields(false) : setDisableAutoFormFields(true)
    } else if (!manualEntry && props.paperPackage) {
      const newFormErrors = {
        contactName: getFormErrors.contactName,
        position: getFormErrors.position,
        centreEmail: getFormErrors.centreEmail,
        centreEmailConfirm: getFormErrors.centreEmailConfirm,
        financeEmail: getFormErrors.financeEmail,
        financeEmailConfirm: getFormErrors.financeEmailConfirm,
        termsAndConditions: getFormErrors.termsAndConditions,
        phone: getFormErrors.phone,
      };
      setFormErrors(newFormErrors);
      setDisableAutoFormFields(true)
    } else if (!manualEntry) {
      const newFormErrors = {
        contactName: getFormErrors.contactName,
        position: getFormErrors.position,
        centreEmail: getFormErrors.centreEmail,
        centreEmailConfirm: getFormErrors.centreEmailConfirm,
        financeEmail: getFormErrors.financeEmail,
        financeEmailConfirm: getFormErrors.financeEmailConfirm,
        termsAndConditions: getFormErrors.termsAndConditions,
      };
      setFormErrors(newFormErrors);
      setDisableAutoFormFields(true)
    } else {
      const newFormErrors = {
        contactName: getFormErrors.contactName,
        position: getFormErrors.position,
        centreEmail: getFormErrors.centreEmail,
        centreEmailConfirm: getFormErrors.centreEmailConfirm,
        financeEmail: getFormErrors.financeEmail,
        financeEmailConfirm: getFormErrors.financeEmailConfirm,
        termsAndConditions: getFormErrors.termsAndConditions,
        centreName: getFormErrors.centreName,
        centreAddress: getFormErrors.centreAddress,
        postcode: getFormErrors.postcode,
      };
      setFormErrors(newFormErrors);
      setDisableAutoFormFields(false)
    }
  }, [formErrors, props.paperPackage]);
  
  const stopAutoFormFields = () => {
    removeAutoFormFieldErrors();
  };

  
  const updateRenewalFormValues = () => {
    if (previousFormValuesProps !== JSON.stringify(props.formValues)) {
      const propsFormValues = props.formValues
      const newFormValues = {...formValues, ...propsFormValues}
      setFormValues(newFormValues);
      if (Object.values(propsFormValues).some(itemValue => itemValue) && props.renewal === true) {
        setFormVisibility(true);
      }
    }
  }

 
  useEffect(() => {
    if (
      previousFormErrors !==
      JSON.stringify(formErrors)
    ) {
      for (let key in formErrors) {
        if (
          formErrors[key] === false || 
          formErrors[key] === ""
        ) {
          setFormValid(true);
        } else {
          setFormValid(false);
          break;
        }
      }
      stopAutoFormFields();
  };
  
    updateRenewalFormValues();
if (props.paperPackage) {
  setPhoneLabel("Phone number*");
} else {
  setPhoneLabel("Phone number");
}
    return props.updateMainState("formValues", formValues);
  }, [formValues, formErrors, props.formValues])

    const { updateDiscountCode, basket, renewal } = props;
    const basketZero = basket.map((basket, index) =>
      basket.price === ".0000" ? 0 : parseInt(basket.price, 10)
    );
    const basketSubTotal = basketZero.reduce((a, b) => a + b, 0);
    const open = Boolean(anchorEl);

    return (
      <Container fluid className="form__section" direction="row">
        <div xs={12}>
          {renewal ? (
            <Fragment>
              <h1>Renewal Form</h1>
              <p>
                <strong>
                  Please complete and submit this form to renew your original
                  package.
                </strong>
              </p>
            </Fragment>
          ) : (
            <Fragment>
              <h1>Enter your school details</h1>
              <p>
                <strong>
                  {props.brandName} products and services can only be
                  ordered by educational institutions. Please provide us with a
                  purchase order number to help with processing and tracking
                  your order.
                </strong>
              </p>
              <p className="important">
                <strong>
                  Please note we are unable to sell {props.brandName} to
                  students, parents or tutors.
                </strong>
              </p>
              <PostCodeSearch
                updateSchoolDetails={updateForm}
                showForm={setFormVisibility}
                disableAutoFormFields={stopAutoFormFields}
                enableAutoFormFields={enableAutoFormFields}
                setFormVisibility={setFormVisibility}
                setManualEntry={setManualEntry}
              />
            </Fragment>
          )}

          {showForm && (
            <Form noValidate autoComplete="on">
              <FloatingLabel
              label={centreNameLabel}
            >
              <Form.Control
                className="form__text-field"
                disabled={disableAutoFormFields}
                name="centreName"
                value={formValues.centreName}
                id="centre-name"
                placeholder="centreName"
                onChange={handleInputChange}
                onBlur={() => handleBlur("centreName")}
                required={!disableAutoFormFields}
              />
            </FloatingLabel>
            {!formErrors.centreName ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.centreName}
              </div>}
            <FloatingLabel
            label="Dfe number"
            >
              <Form.Control
                className="form__text-field"
                disabled={disableAutoFormFields}
                name="dfeNumber"
                placeholder="dfe"
                value={
                  formValues.dfeNumber
                }
                id="dfe-number"
                onChange={handleInputChange}
              />
            </FloatingLabel>
            <FloatingLabel
            label={centreAddressLabel}
            >
              <Form.Control
                style={{height: 77}}
                as="textarea"
                rows={6}
                placeholder="school"
                className="form__text-field"
                disabled={disableAutoFormFields}
                name="centreAddress"
                value={formValues.centreAddress}
                id="centre-address"
                onChange={handleInputChange}
                onBlur={() => handleBlur("centreAddress")}
                required={!disableAutoFormFields}
              />
            </FloatingLabel>
            {!formErrors.centreAddress ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.centreAddress}
              </div>}
            <FloatingLabel
            label={postcodeLabel}
            >
              <Form.Control
                className="form__text-field"
                disabled={disableAutoFormFields}
                name="postcode"
                value={formValues.postcode}
                id="postcode"
                placeholder="postcode"
                onChange={handleInputChange}
                onBlur={() => handleBlur("postcode")}
                required={!disableAutoFormFields}
              />
            </FloatingLabel>
            {!formErrors.postcode ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.postcode}
              </div>}
            {props.paperPackage === true ?
              <div className="package-info-container">
                <i className="fas fa-info-circle package-info-icon"></i>
                <p className="package-info-text">
                  <strong>Address:</strong> If your delivery address differs from the displayed address or you request delivery outside mainland UK, 
                  please complete your order and contact our support team to update your address.
                </p>
              </div>
            :
              ""}
            <FloatingLabel
            label="Country"
            >
              <Form.Select
                className="form__text-field"
                name="country"
                value={formValues.country}
                id="country"
                placeholder="country"
                aria-label="Country"
                onChange={handleInputChange}
              >
                 <option>{' '}</option>
                {countries.map(country => (
                  <option key={country.Code} value={country.Code}>
                    {country.Name}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
            <FloatingLabel
            label={phoneLabel}
            >
              <Form.Control
                className="form__text-field"
                name="phone"
                placeholder="phone"
                value={formValues.phone}
                id="phone"
                required={props.paperPackage}
                onChange={handleInputChange}
                onBlur={() => handleBlur("phone")}
              />
            </FloatingLabel>
            {props.paperPackage === true ?
              formErrors.phone.length === 0 ? null 
                :
              <div className="errorFeedback__message">
                {formErrors.phone}
              </div>
              :
              ""}
            <FloatingLabel
            label="Purchase order number"
            >
              <Form.Control
                className="form__text-field"
                name="purchaseOrder"
                value={formValues.purchaseOrder}
                id="purchase-order"
                placeholder="po"
                onChange={handleInputChange}
              />
            </FloatingLabel>
            <FloatingLabel
            label="Vat number"
            >
              <Form.Control
                className="form__text-field"
                name="vatNumber"
                placeholder='vat'
                value={formValues.vatNumber}
                id="vat-number"
                onChange={handleInputChange}
                />
            </FloatingLabel>
            <FloatingLabel
            label="Name*"
            >
              <Form.Control
                className="form__text-field"
                name="contactName"
                placeholder='name'
                value={formValues.contactName}
                id="contact-name"
                required
                autoComplete="new-password"
                onChange={handleInputChange}
                onBlur={() => handleBlur("contactName")}
              />
            </FloatingLabel>
              {formErrors.contactName.length === 0 ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.contactName}
              </div>}
            <FloatingLabel
            label="Position*"
            >
              <Form.Select
                className="form__text-field"
                name="position"
                value={formValues.position}
                id="position"
                placeholder="position"
                onChange={handleInputChange}
                onBlur={() => handleBlur("position")}
                required
              >
                <option> </option>
                {form.position.map(position => (
                  <option key={position} value={position}>
                    {position}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
              {formErrors.position.length === 0 ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.position}
              </div>}
              <FloatingLabel
            label="School email (for login details and updates)*"
            >
              <Form.Control
                className="form__text-field"
                name="centreEmail"
                id="email"
                placeholder="centreEmail"
                onChange={handleInputChange}
                onBlur={() => handleBlur("centreEmail")}
                required
                autoComplete="new-password"
              />
            </FloatingLabel>
              {formErrors.centreEmail.length === 0 ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.centreEmail}
              </div>}
              <FloatingLabel
            label="Confirm school email*"
            >
              <Form.Control
                className="form__text-field"
                name="centreEmailConfirm"
                id="email2"
                placeholder="email2"
                onChange={handleInputChange}
                onBlur={() =>
                  confirmValue("centreEmailConfirm", "centreEmail")
                }
                required
                autoComplete="new-password"
              />
            </FloatingLabel>
              {formErrors.centreEmailConfirm.length === 0 ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.centreEmailConfirm}
              </div>}
              <Fragment>
                <FloatingLabel
                  label="Finance email (for invoice)*"
                  >
                <Form.Control
                  className="form__text-field"
                  name="financeEmail"
                  id="finance-email"
                  placeholder="finanaceEmail"
                  onChange={handleInputChange}
                  onBlur={() => handleBlur("financeEmail")}
                  required
                  autoComplete="new-password"
                />
            </FloatingLabel>
              {formErrors.financeEmail.length === 0 ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.financeEmail}
              </div>}
              <FloatingLabel
            label="Confirm finance email*"
            >
                <Form.Control
                  className="form__text-field"
                  name="financeEmailConfirm"
                  id="finance-email--confimation"
                  placeholder="financeEmailConfirmation"
                  onChange={handleInputChange}
                  onBlur={() =>
                    confirmValue("financeEmailConfirm", "financeEmail")
                  }
                  required
                  autoComplete="new-password"
                />
            </FloatingLabel>
              {formErrors.financeEmailConfirm.length === 0 ? null 
              :
              <div className="errorFeedback__message">
                {formErrors.financeEmailConfirm}
              </div>}
                <DiscountCode
                  setPromo_code={props.setPromo_code}
                  showForm={props.showForm}
                />
              </Fragment>

              <br />
              <div className="tandc-div">
                *
                <span className="tandc-check">
                  <Form.Check
                    onChange={handleInputChange}
                    name="termsAndConditions"
                    checked={formValues.termsAndConditions}
                    type="checkbox"
                    value="terms and conditions"
                  />
                </span>
                <div>
                  I agree to the&nbsp;
                  <a
                    href="http://www.doublestruck.co.uk/terms-and-conditions/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Use
                  </a>
                  &nbsp;and have read the&nbsp;
                  <a
                    href="http://www.doublestruck.co.uk/privacy-statement/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Notice
                  </a>
                </div>
              </div>
              <div className={"formComments"}>
                  {formValid ? null : (
                    <p className="alert">
                      <i className="fa fa-exclamation-circle error"/>{' '}
                      Please correct the highlighted fields.
                    </p>
                  )}
                  {formValues.termsAndConditions ? null : (
                    <p className="alert">
                      <i className="fa fa-exclamation-circle error"/>{' '}
                      You must agree to the terms and conditions.
                    </p>
                  )}
              </div>
              <Button
                onClick={() => {
                  handleForm();
                  window.scroll(0, 0);
                }}
                className="complete-order-btn final"
                disabled={props.basket.length === 0}
              >
                Submit Order
              </Button>
            </Form>
          )}
        </div>
      </Container>
    );
  }

SchoolDetails.propTypes = {
  formValues: PropTypes.object
};

export default SchoolDetails;
